import React from "react";
import { motion } from "framer-motion";

const tools = [
  "AI Automations",
  "Dashboards",
  "Social Media",
  "Shopify",
  "E-commerce",
  "Software",
  "Websites",
  "Chatbots",
  "Content",
];

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-24 sm:py-32 px-4 sm:px-6 bg-[#0D0D0D] text-[#FDFBF7] border-y-[3px] border-[#0D0D0D] overflow-hidden"
    >
      <div className="relative mx-auto max-w-7xl">
        <div className="grid lg:grid-cols-12 gap-10">

          {/* LEFT */}
          <div className="lg:col-span-7">
            <span className="font-mono text-xs uppercase tracking-[0.3em] text-[#FFD800]">
              [04] — About
            </span>

            <h2 className="mt-3 font-display font-black uppercase text-5xl sm:text-6xl lg:text-7xl leading-[0.92] tracking-tighter">
              A studio of <br />
              <span className="text-[#FFD800]">one</span>. A team of{" "}
              <span className="font-script normal-case text-[#00E5FF] text-5xl sm:text-6xl lg:text-7xl">
                many
              </span>.
            </h2>

            <div className="mt-6 inline-flex items-center gap-3 brut-border brut-shadow-sm bg-[#FDFBF7] text-[#0D0D0D] pl-2 pr-4 py-2">
              <span className="w-8 h-8 bg-[#FF0055] text-white flex items-center justify-center font-display font-black brut-border text-sm">
                IA
              </span>

              <div className="leading-tight">
                <div className="font-mono text-[10px] uppercase tracking-widest text-[#4A4A4A]">
                  Founder
                </div>

                <div className="font-display font-black uppercase tracking-tight text-base">
                  Incia Anand
                </div>
              </div>
            </div>

            <div className="mt-8 grid md:grid-cols-2 gap-6 font-body text-[#FDFBF7]/85 leading-relaxed text-lg">
              <p>
                I'm a senior software engineer turned solo builder.
                I have 7+ years of work experience with Product firms 
                like Oracle, Dell Technologies and Newton School.
                At IncInk (In-Sync) Creative my aim is to build
                and ship quality digital solutions for unique ideas,
                "insync" with you!
                
              </p>

              <p>
                If you are a small business looking to scale with the 
                help of tech, reach out! When the work calls for it, 
                I pull in a tight bench of trusted collaborators like
                illustrators, motion designers, copywriters to keep 
                velocity high without losing the craft.
              </p>
            </div>

            <div className="mt-10 flex flex-wrap gap-2">
              {tools.map((t) => (
                <motion.span
                  key={t}
                  initial={{ opacity: 0, y: 10 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  className="px-3 py-1.5 bg-[#FDFBF7] text-[#0D0D0D] brut-border font-mono text-xs uppercase tracking-widest"
                >
                  {t}
                </motion.span>
              ))}
            </div>
          </div>

          {/* RIGHT */}
          <div className="lg:col-span-5">
            <div className="relative">

              <div className="brut-border brut-shadow-lg bg-[#FFD800] text-[#0D0D0D] p-8 sm:p-10 pb-24 rotate-1 min-h-[420px] flex flex-col justify-between">

                <div>
                  <div className="font-mono text-xs uppercase tracking-[0.3em] text-[#0D0D0D]/70 mb-4">
                    Manifesto / 001
                  </div>

                  <p className="font-display font-black uppercase text-3xl sm:text-4xl leading-[0.95] tracking-tight">
                    Ship fast.
                    <br />
                    Charge fair.
                    <br />
                    <span className="text-[#FF0055]">
                      Stay weird.
                    </span>
                  </p>
                </div>

                <div className="mt-8 grid grid-cols-2 gap-4 font-mono text-xs uppercase tracking-widest">

                  <div className="brut-border bg-white p-3">
                    <div className="text-[#4A4A4A] text-[10px]">
                      Response time
                    </div>

                    <div className="font-display font-black text-xl normal-case">
                      &lt; 24 hrs
                    </div>
                  </div>

                  <div className="brut-border bg-[#00E5FF] p-3">
                    <div className="text-[#0D0D0D]/70 text-[10px]">
                      Project start
                    </div>

                    <div className="font-display font-black text-xl normal-case">
                      ~1 week
                    </div>
                  </div>

                </div>
              </div>

              {/* Sticker */}
              <div className="absolute -bottom-20 left-2 bg-[#FDFBF7] text-[#0D0D0D] brut-border brut-shadow p-4 max-w-[260px] -rotate-3">
                <div className="font-script text-3xl leading-none">
                  made with care —
                </div>

                <div className="mt-1 font-mono text-xs uppercase tracking-widest">
                  Incia Anand · IncInk Creative
                </div>
              </div>

              {/* Floating badge */}
              <div className="absolute -top-5 -right-4 bg-[#FF0055] text-white brut-border brut-shadow-sm px-3 py-2 font-display font-black uppercase text-sm rotate-6">
                Est. 2025
              </div>

            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
